import { render, staticRenderFns } from "./N1OsDados.vue?vue&type=template&id=4cb967ec&scoped=true"
import script from "./N1OsDados.vue?vue&type=script&lang=js"
export * from "./N1OsDados.vue?vue&type=script&lang=js"
import style1 from "./N1OsDados.vue?vue&type=style&index=1&id=4cb967ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb967ec",
  null
  
)

export default component.exports